import { render, staticRenderFns } from "./FontsReplacementMatcherModal.vue?vue&type=template&id=2c505c9b&scoped=true"
import script from "./FontsReplacementMatcherModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./FontsReplacementMatcherModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FontsReplacementMatcherModal.vue?vue&type=style&index=0&id=2c505c9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c505c9b",
  null
  
)

export default component.exports